import { api } from './api';

export type UserRole = 'admin' | 'director' | 'manager' | 'collaborator' | 'executive';

export interface TeamMember {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  teamId: string | null;
}

export const usersApi = {
  teamMembers: (token: string) =>
    api.get<TeamMember[]>('/api/v1/users/team-members', { accessToken: token }),
  // Liste complète (direction uniquement) - utilisée par les écrans KPI/config
  // pour proposer un filtre par collaborateur sur l'ensemble du périmètre.
  list: (token: string, opts: { activeOnly?: boolean } = {}) => {
    const qs = opts.activeOnly ? '?active_only=true' : '';
    return api.get<TeamMember[]>(`/api/v1/users/${qs}`, { accessToken: token });
  },
};
